import React from 'react';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { supplierDetailsQuery } from '@store/suppliers/details';

import { Add } from '@icons/index';

import DocumentsTableSupplierUnit from '@screens/admin/suppliers/details/supplierUnits/documents/Documents.table';

const DocumentsTabSupplierUnit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack flex={1} spacing={2} mt="-35px">
      <Stack direction="row" alignItems="center" justifyContent="flex-end">
        <Stack direction="row" alignItems="center" spacing={2}>
          {!supplierDetailsQuery.isArchived && (
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button
                onClick={() => navigate('add')}
                variant="contained" color="primary"
                startIcon={<Add />}>
                {t('suppliers.details.documents.addButton')}
              </Button>
            </Stack>
          )}
        </Stack>
      </Stack>
      <DocumentsTableSupplierUnit />
    </Stack>
  );
};

export default DocumentsTabSupplierUnit;
